import gql from 'graphql-tag';

import { NotificationFragment } from 'common/components/NotificationsWidget/queries';

export const subscribedNotificationCreated = gql`
  subscription subscribedNotificationCreated {
    create: notificationCreated(subscribed: true) {
      ...Notification
    }
  }

  ${NotificationFragment}
`;

export const subscribedNotificationUpdated = gql`
  subscription subscribedNotificationUpdated($id: ID!) {
    update: notificationUpdated(id: $id) {
      ...Notification
    }
  }

  ${NotificationFragment}
`;
